module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Dramatis_Personae"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_vm._v("Dramatis Personae"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page7"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("It may be helpful to the reader to have to hand a quick reference guide to the roles of some of the players in this drama and their positions at the time.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Admiral Reginald Bacon: commanding Dover Patrol 1915–1918")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Admiral Prince Louis Battenberg: First Sea Lord 1912–1914")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Vice Admiral Lewis Bayly: commanding Queenstown and Western Approaches 1915–1919")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Admiral Sir David Beatty: commanding Battle Cruiser Force 1914–1916, Commander-in-Chief Grand Fleet 1916–1919")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Admiral Lord Charles Beresford: MP and retired admiral")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Captain Hugh Brocklebank: captain HMS "), _c('i', [_vm._v("Changuinola")])]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Admiral Sir George Callaghan: Commander-in-Chief Home Fleet 1911–1914")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Rt Hon Winston Churchill: First Lord of the Admiralty 1911–1915")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Rear Admiral Sir Christopher Cradock: commanding 4th Cruiser Squadron")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Commander Selwyn Day: captain HMS "), _c('i', [_vm._v("Dundee")])]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Rear Admiral Sir Dudley de Chair: commanding 10th Cruiser Squadron 1914–1916")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Commander (later Captain) George England: captain HMS "), _c('i', [_vm._v("Orvieto")])]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Admiral of the Fleet Lord John (Jacky) Fisher: First Sea Lord 1904–1910, 1914–1915")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Sir Eric Geddes: First Lord of the Admiralty 1917–1919")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Commander Francis Grenfell: HMS "), _c('i', [_vm._v("Cedric")])]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Admiral Sir Frederick Hamilton: Second Sea Lord 1914–1916")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Admiral Sir Henry Jackson: Chief of Staff, Admiralty 1913–1915, First Sea Lord 1915–1916")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Admiral Sir John Jellicoe: Commander-in-Chief Grand Fleet 1914–1916, First Sea Lord 1916–1917")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Vice Admiral Roger Keyes: commanding Dover Patrol 1918")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Captain Francis Martin Leake: captain HMS "), _c('i', [_vm._v("Achilles")])]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Midshipman Ernest McKeag: HMS "), _c('i', [_vm._v("India")]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page8"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Rt Hon Reginald McKenna: First Lord of the Admiralty 1908–1911")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Lieutenant John Shuter: First Lieutenant HMS "), _c('i', [_vm._v("Changuinola")])]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Rear Admiral Archibald Stoddart: commanding 5th Cruiser Squadron")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Vice Admiral Reginald Tupper: commanding 10th Cruiser Squadron 1916–1917")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Admiral Sir Arthur Wilson: First Sea Lord 1910–1911")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2907e408","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Dramatis_Personae.vue
// module id = 78
// module chunks = 0